import Layout from '@/views/layout'
export default {
    path: '/datareport',
    menuName: '数据报表',
    component: Layout,
    name: 'datareport',
    meta: { title: 'datareport', icon: 'APP-management', iconType: 'svg' },
    children: [
        {
          path: 'tripreport',
          name: 'tripreport',
          menuName: '行程统计',
          component: () => import('@/views/datareport/tripreport'),
          meta: { title: 'tripreport', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'vehicleinformation',
          name: 'vehicleinformation',
          menuName: '车辆信息统计',
          component: () => import('@/views/datareport/vehicleinformation'),
          meta: { title: 'vehicleinformation', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'carldlereport',
          name: 'carldlereport',
          menuName: '车辆闲置统计',
          component: () => import('@/views/datareport/carldlereport'),
          meta: { title: 'carldlereport', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'fuelconsumption',
          name: 'fuelconsumption',
          menuName: '燃料消耗统计',
          component: () => import('@/views/datareport/fuelconsumption'),
          meta: { title: 'fuelconsumption', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'offline',
          name: 'offline',
          menuName: '离线/在线报警',
          component: () => import('@/views/datareport/offline'),
          meta: { title: 'offline', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'vibration',
          name: 'vibration',
          menuName: '异动统计',
          component: () => import('@/views/datareport/vibration'),
          meta: { title: 'vibration', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'ignition',
          name: 'ignition',
          menuName: '点火统计',
          component: () => import('@/views/datareport/ignition'),
          meta: { title: 'ignition', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'overspeed',
          name: 'overspeed',
          menuName: '超速统计',
          component: () => import('@/views/datareport/overspeed'),
          meta: { title: 'overspeed', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'geofencereport',
          name: 'geofencereport',
          menuName: '电子围栏统计',
          component: () => import('@/views/datareport/geofencereport'),
          meta: { title: 'geofencereport', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'dtcreport',
          name: 'dtcreport',
          menuName: '故障信息统计',
          component: () => import('@/views/datareport/dtcreport'),
          meta: { title: 'dtcreport', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'subcompanyreport',
          name: 'subcompanyreport',
          menuName: '经销商车辆统计',
          component: () => import('@/views/datareport/subcompanyreport'),
          meta: { title: 'subcompanyreport', icon: 'notice', iconType: 'svg' }
        },
        {
          path: 'departmentreport',
          name: 'departmentreport',
          menuName: '门店车辆统计',
          component: () => import('@/views/datareport/departmentreport'),
          meta: { title: 'departmentreport', icon: 'notice', iconType: 'svg' }
        },
        
        
        
       
        
    ]
}